import React from 'react';
import { withRouter } from 'react-router';
import { CongratulationTile } from 'components/CongratulationTile';
import { Button } from 'components/Button';
import { ROUTES } from 'config/constants';
import EnvelopIcon from './envelop.svg';

const Congratulation = (props) => (
  <CongratulationTile.AloneWrapper>
    <CongratulationTile
      title="Password Reset Email Sent"
      titleStyle={{ maxWidth: '400px' }}
      description="An email has been sent to you.  Follow the directions in the email to reset your password."
      icon={<EnvelopIcon width="88px" height="88px" />}
      bottomPanel={
        <div className="flex justify-content-center">
          <Button
            className="_red"
            onClick={() => {
              props.history.replace(ROUTES.LOGIN);
            }}
          >
            Sign In
          </Button>
        </div>
      }
    />
  </CongratulationTile.AloneWrapper>
);

export default withRouter(Congratulation);
